import React, { ReactNode } from "react";
import Box from "../../shared/ui/display/Box";
import Container from "../../shared/ui/display/Container";
import Navbar from "../../shared/ui/navigation/Navbar";
import useStyles from "./useStyles";

interface UnauthenticatedLayoutProps {
  children?: ReactNode;
}

const GuestLayout = ({ children }: UnauthenticatedLayoutProps) => {
  const { layoutRoot, containerRoot } = useStyles();

  return (
    <Box className={layoutRoot}>
      <Navbar />
      <Container className={containerRoot}>
        <Box mx="auto" maxWidth={500}>
          {children}
        </Box>
      </Container>
    </Box>
  );
};

export default GuestLayout;
